// Media queries
export const devices = {
  $mobileXS: "@media (min-width: 375px)",
  $mobile: "@media (min-width: 480px)",
  $tabletPortrait: "@media (min-width: 768px)",
  $tabletLandScape: "@media (min-width: 1024px)",
  $desktop: "@media (min-width: 1440px)"
};
